// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "meet_and_greet-1Csia";
export { _1 as "__esModule", _2 as "meet_and_greet" }
export default { "__esModule": _1, "meet_and_greet": _2 }
